// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// ---- CSP nonce + Turbolinks ------------------------------------------------
// Turbolinks fetches the next page over XHR and injects that response's inline
// <script> elements into the CURRENT document. Those scripts carry the nonce of
// the *fetched* response, but the CSP being enforced is still the one delivered
// with the original document load -- and content_security_policy.rb generates a
// fresh nonce per request. The two never match, so every inline script is
// blocked on navigation ("Executing inline script violates ... script-src").
//
// Read the nonce once, at initial load: Turbolinks treats the csp-nonce meta as
// a provisional head element and replaces it with the fetched page's value, so
// re-reading it later yields a nonce the enforced policy does not accept.
var cspNonceMeta = document.querySelector("meta[name='csp-nonce']")
var ORIGINAL_CSP_NONCE = cspNonceMeta && cspNonceMeta.content

if (ORIGINAL_CSP_NONCE) {
  document.addEventListener("turbolinks:before-render", function (event) {
    var newBody = event.data && event.data.newBody
    if (!newBody) return
    // Stamp the document's own nonce on incoming scripts before Turbolinks
    // clones them into the live DOM.
    Array.prototype.forEach.call(newBody.querySelectorAll("script"), function (script) {
      script.setAttribute("nonce", ORIGINAL_CSP_NONCE)
    })
  })
}

// jQuery (must come before plugins that need it)
import $ from "jquery";
window.$ = $;
window.jQuery = $;

// Popper + Bootstrap 5
import "bootstrap"
// Slick (need both JS and CSS)
import "slick-carousel"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "jquery-validation"; // adds $.fn.validate



// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
